var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Math, content, continueBtnText, doneText, hasNarration, hasPrompt, i18n, isInternetExplorer, prompt, submitUp, title, undefined, written) {
buf.push("<div class=\"content-fit content-md-fill content-sm-ver\"><div class=\"content-md-ver text-center\"><h1 class=\"fade-in delay-3\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1><div class=\"content-pieces row text-center\">");
// iterate content
;(function(){
  var $$obj = content;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var piece = $$obj[i];

var col = Math.floor(12 / content.length);
if ( content.length === 1)
{
var klass = "col-md-8";
}
else
{
var klass = "col-md-" + col * 2 + " col-lg-" + col
}
klass += " delay-" + (i + 3);
buf.push("<div" + (jade.cls(['content-piece','slide-up','col-sm-12','block-v-sm',klass], [null,null,null,null,true])) + "><div" + (jade.attr("data-index", i, true, false)) + " class=\"btn-reveal\"><div" + (jade.cls(['btn-reveal-title','btn','btn-solid',isInternetExplorer ? "ie" : "flippable"], [null,null,null,true])) + "><h2 class=\"tight content-ver break-word\">" + (null == (jade_interp = written.hyphenate(piece.title)) ? "" : jade_interp) + "</h2></div><div" + (jade.cls(['btn-reveal-desc','block-v-md','block-h-lg','btn','btn-solid',isInternetExplorer ? "ie" : "flippable"], [null,null,null,null,null,true])) + ">" + (null == (jade_interp = written.hyphenate(piece.description) || "&nbsp;") ? "" : jade_interp) + "</div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var piece = $$obj[i];

var col = Math.floor(12 / content.length);
if ( content.length === 1)
{
var klass = "col-md-8";
}
else
{
var klass = "col-md-" + col * 2 + " col-lg-" + col
}
klass += " delay-" + (i + 3);
buf.push("<div" + (jade.cls(['content-piece','slide-up','col-sm-12','block-v-sm',klass], [null,null,null,null,true])) + "><div" + (jade.attr("data-index", i, true, false)) + " class=\"btn-reveal\"><div" + (jade.cls(['btn-reveal-title','btn','btn-solid',isInternetExplorer ? "ie" : "flippable"], [null,null,null,true])) + "><h2 class=\"tight content-ver break-word\">" + (null == (jade_interp = written.hyphenate(piece.title)) ? "" : jade_interp) + "</h2></div><div" + (jade.cls(['btn-reveal-desc','block-v-md','block-h-lg','btn','btn-solid',isInternetExplorer ? "ie" : "flippable"], [null,null,null,null,null,true])) + ">" + (null == (jade_interp = written.hyphenate(piece.description) || "&nbsp;") ? "" : jade_interp) + "</div></div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined,"content" in locals_for_with?locals_for_with.content:typeof content!=="undefined"?content:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"isInternetExplorer" in locals_for_with?locals_for_with.isInternetExplorer:typeof isInternetExplorer!=="undefined"?isInternetExplorer:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"written" in locals_for_with?locals_for_with.written:typeof written!=="undefined"?written:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}